import { Button } from '@stratascratch/ui'
import {
  FacebookOutline,
  Twitter,
  Youtube,
  Linkedin,
} from '@stratascratch/icons'

const FOLLOW_BUTTONS = [
  {
    href: 'https://www.facebook.com/stratascratch',
    icon: <FacebookOutline />,
  },
  {
    href: 'https://www.twitter.com/StrataScratch',
    icon: <Twitter />,
  },
  {
    href: 'https://www.youtube.com/channel/UCW8Ews7tdKKkBT6GdtQaXvQ',
    icon: <Youtube />,
  },
  {
    href: 'https://www.linkedin.com/company/stratascratch/',
    icon: <Linkedin />,
  },
] as const

function FollowButtons() {
  return (
    <div className="flex gap-2">
      {FOLLOW_BUTTONS.map((el) => (
        <Button
          as="anchor"
          variant="outline"
          size="circle"
          key={el.href}
          href={el.href}
        >
          {el.icon}
        </Button>
      ))}
    </div>
  )
}

export default FollowButtons
